export enum QuestionCategory {
  GeneralBehaviourRating = 1,
  BehaviorSpecificMetrics = 2,
  InterventionAndSupportFeedback = 3,
  StakeholderFeedback = 4,
  SelfAssessment = 5,
}

export enum SubQuestionCategory {
  TeacherReflection = 1,
  StudentSelfAssessment = 2,
}

export const DATE_FORMAT = 'yyyy-MM-dd';
